import BaseTooltip from './BaseTooltip';

export default BaseTooltip;